var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wuji-runtime-loading",attrs:{"role":"status","aria-label":_vm.$t('k_47fb3667')}},[_c('div',{staticClass:"wuji-runtime-loading__spinner",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }